import { render, staticRenderFns } from "./project_admin_subcomponent_metavariables_types_editor.vue?vue&type=template&id=ffcba83c&"
import script from "./project_admin_subcomponent_metavariables_types_editor.vue?vue&type=script&lang=js&"
export * from "./project_admin_subcomponent_metavariables_types_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports